module.exports = __webpack_public_path__ + "img/birsdaybuttonPressed.39cee10f.png";